import { render } from "./policyList.vue?vue&type=template&id=46e9fb7c"
import script from "./policyList.vue?vue&type=script&lang=js"
export * from "./policyList.vue?vue&type=script&lang=js"

import "./policyList.vue?vue&type=style&index=0&id=46e9fb7c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__